import { createContext } from "preact";
import { useContext, useState } from "preact/hooks";

const StepsContext = createContext({
    steps: [],
    getActiveStep: () => {},
    goToNextStep: () => undefined,
    canProceedToNextStep: () => Boolean,
});

export function StepsProvider({ children }) {
    const [steps, setSteps] = useState([]);

    const goToNextStep = () => {
        let nextIndex = undefined;
        setSteps(steps.map((step, index) => {
            if (step.active) {
                nextIndex = index + 1;
                step.active = false;
                step.done = true;
            }

            if (index === nextIndex) {
                step.active = true;
            }

            return step;
        }));
    }

    /**
     * @returns {boolean}
     */
    const canProceedToNextStep = () => {
        return !getActiveStep().last;
    }

    const goToPrevStep = () => {
        let prevIndex = undefined;
        setSteps(steps.map((step, index) => {
            if (step.active) {
                prevIndex = index - 1;
                step.active = false;
                step.done = false;
            }

            if (steps[prevIndex]) {
                steps[prevIndex].active = true;
            }

            return step;
        }));
    }

    const addStep = (title, active, last, first, name) => {
        setSteps((prevState) => [...prevState, { title, active, last, first, name }]);
    }

    const getActiveStep = () => {
        return steps.find(step => step.active) || {};
    }

    return (
        <StepsContext.Provider value={{ steps, addStep, goToNextStep, getActiveStep, goToPrevStep, canProceedToNextStep }}>
            {children}
        </StepsContext.Provider>
    )
}

export function useStepsContext() {
    return useContext(StepsContext);
}

export default StepsContext;
